import Seo from "@/components/Seo";
import { LinkButton } from "@/components/Button";
import { motion } from "framer-motion";

const NotFound = () => (
  <>
    <Seo title="Page Not Found | Kryvo Technologies" description="The page you are looking for could not be found." />
    <section className="grid-bg flex min-h-[80vh] items-center bg-kryvo-mist pt-[72px]" data-testid="not-found-page">
      <div className="container-x flex flex-col items-center py-20 text-center">
        <motion.p
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="font-display text-7xl font-semibold text-kryvo-green sm:text-8xl"
        >
          404
        </motion.p>
        <h1 className="mt-4 text-2xl font-semibold text-kryvo-ink sm:text-3xl">This page took a wrong turn.</h1>
        <p className="mt-3 max-w-md text-base text-kryvo-ink/60">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <div className="mt-8">
          <LinkButton to="/" variant="primary" testId="not-found-home-link">
            Back to Home
          </LinkButton>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
